export default {
  userFlow: state => state.userFlow,
  userFlowHasImages: state => state.userFlowHasImages
}
